<template>
    <div>
        <toolbar />
        <router-view />
    </div>
</template>

<script>
import Toolbar from '../components/Toolbar'

export default {
    components: {
        Toolbar
    }
}
</script>

<style>

</style>
